import { Fragment, useState } from "react";
import {
  Modal,
  Col,
  Row,
  Button,
  Label,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { ErrorMessage } from "@hookform/error-message";
import { toast, ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
import { API_URL } from "../../config/Config";
import axios from "axios";
import { useSelector } from "react-redux";

const BugReport = (props) => {
  const user = useSelector((state) => state.user);
  const [modal, setModal] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (data) => {
    try {
      let name = "";
      let email = "unkown@user.com";
      let subject = window.location.href;
      if (user.isAuthenticated) {
        name = `${user["first_name"]} ${user["last_name"]}`;
        email = user.email;
      }

      const sendData = {
        ...data,
        name,
        email,
        subject,
      };

      const options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "Content-Type": "application/json",
        },
        data: sendData,
        url: `${API_URL}contact`,
      };
      const response = await axios(options);

      if (response.status > 199 && response.status < 300) {
        toast.success(
          "درخواست شما با موفقیت ثبت شد. کارشناسان ما با شما تماس خواهند گرفت. ",
          { position: toast.POSITION.TOP_LEFT, closeOnClick: true }
        );
        await setModal(false);
      } else {
        toast.error("پرکردن فیلدهای ستاره دار الزامی است. ", {
          position: toast.POSITION.TOP_LEFT,
          closeOnClick: true,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Fragment>
      <Button className="bug-report-btn" onClick={() => setModal(!modal)}>
        ثبت پیشنهاد و گزارش خطا
        {/* <img src="../../assets/images/bugreport-btn.png" alt="ثبت پیشنهاد و گزارش خطا" className='bug-icon'/> */}
      </Button>
      <Modal
        size="md"
        isOpen={modal}
        toggle={() => setModal(!modal)}
        className="bug-report-modal rtl"
      >
        <ModalHeader toggle={() => setModal(!modal)}>
          ثبت پیشنهادات و گزارش خطا
        </ModalHeader>
        <ModalBody>
          {/*<Card className='login-card bug-report-card'>*/}
          <div className="container-fluid p-0">
            <Row className="no-gutters equal">
              <Col className="p-3">
                <div className="mb-2">
                  <form onSubmit={handleSubmit(onSubmit)} className="rtl">
                    <p>
                      بازدید کننده گرامی، ضمن تشکر از بازدید شما از سامانه
                      فرابازار، <br />
                      با ارسال پیشنهادات و یا گزارش خطاهای احتمالی سامانه، ما را
                      در تکمیل و بهینه سازی آن یاری کنید.
                    </p>
                    <br />
                    <div className="form-group">
                      <Label>شرح خطا / پیشنهادات :</Label>
                      <textarea
                        className={
                          errors.description
                            ? "is-invalid form-control comment-box"
                            : "form-control comment-box"
                        }
                        placeholder="شرح خطا / پیشنهادات"
                        name="description"
                        ref={register({
                          required: "فیلد شرح خطا / پیشنهادات اجباری است !",
                          minLength: {
                            value: 20,
                            message:
                              "متن ارسالی شما نباید کمتر از 20 کارکتر باشد.",
                          },
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="description"
                        as="p"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="text-right">
                      <br />
                      <Button
                        type="submit"
                        value="Submit"
                        color="primary"
                        size="lg"
                        className="btn-blue"
                      >
                        <i className="fas fa-paper-plane ml-1" /> ارســــال
                      </Button>
                    </div>
                  </form>
                  <ToastContainer
                    newestOnTop={true}
                    autoClose={5000}
                    draggable
                    closeOnClick
                  />
                </div>
              </Col>
            </Row>
          </div>
          {/*</Card>*/}
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default BugReport;
